<div class="form-signin-container">
  <div class="form-signin">
    <img src="/logo.svg" alt="Home" style="max-height:200px">
    <h3>Form Builder App Login</h3>
    <input
      type="email"
      [(ngModel)]="email"
      pInputText
      placeholder="Email address" required autofocus>
    <input
      type="password"
      pInputText
      [(ngModel)]="passw"
      id="inputPassword" class="form-control" placeholder="Password" required>
    <p-button label="Sign in" size="large" (onClick)="login()"></p-button>
  </div>
</div>
